import { Divider } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { OLPaper } from "OLPaper";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    chartBox: {
      display: "flex",
      height: "100%",
    },
    gridChild: {
      display: "flex",
      flexDirection: "column",
      margin: 16,
    },
    chartTable: {
      alignItems: "center",
      display: "flex",
      height: theme.spacing(17),
      justifyContent: "space-between",
      whiteSpace: "nowrap",
      width: "100%",
      "& + &": {
        borderTop: `1px solid ${theme.gray50}`,
      },
    },
    chartSmallText: {
      color: theme.gray400,
      fontSize: 14,
      lineHeight: theme.spacing(8),
      marginBottom: theme.spacing(6),
    },
    chartLargeText: {
      color: theme.gray800,
      fontSize: 24,
      lineHeight: theme.spacing(14),
    },
    table: {
      flex: 1,
      margin: 16,
    },
  }),
);
type Table = {
  label: string;
  value?: string | number;
};
type Props = {
  header: string | React.ReactNode;
  subheader: string;
  table: Array<Table>;
  className?: string;
};
export function ChartBox({ header, subheader, table, className }: Props) {
  const classes = useStyles();

  return (
    <OLPaper className={classes.chartBox} noPadding>
      <div className={`${classes.gridChild} ${className || ""}`}>
        <div
          className={classes.chartSmallText}
          data-test-id="single-member-chart-box-subheader"
        >
          {subheader || <Skeleton width={100} />}
        </div>
        <div
          className={classes.chartLargeText}
          data-test-id="single-member-chart-box-header"
        >
          {header || <Skeleton width={100} />}
        </div>
      </div>
      <Divider flexItem orientation="vertical" />
      <div className={classes.table}>
        {table.map((item, index) => (
          <div className={classes.chartTable} key={index}>
            <span data-test-id={`single-member-chart-box-${index}-label`}>
              {item.label}
            </span>
            <span data-test-id={`single-member-chart-box-${index}-value`}>
              {item.value || typeof item.value === "number" ? item.value : "-"}
            </span>
          </div>
        ))}
      </div>
    </OLPaper>
  );
}
